/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
import React from 'react'

import { EuiListGroupItem, EuiText, useEuiTheme } from '@elastic/eui'

import type { FC } from 'react'

type FeatureBulletProps = {
  feature: string
}

export const FeatureBulletListGroupItem: FC<FeatureBulletProps> = ({ feature }) => {
  const { euiTheme } = useEuiTheme()

  return (
    <EuiListGroupItem
      label={<EuiText size='s'>{feature}</EuiText>}
      iconType='check'
      iconProps={{ color: euiTheme.colors.success }}
      wrapText={true}
    />
  )
}
